module.exports = __webpack_public_path__ + "static/img/logo.79b9ec41.png";